/**
 * CSRF
 *
 */

$(function() {
	var csrfToken = $('meta[name="csrfToken"]').attr('content');
	var hidden = $('<input type="hidden" name="CSRF" />').val(csrfToken);

	$(document).on('submit', 'form[method!="get"][method!="GET"]', function () {
		if ($(this).find('input[name="CSRF"]').length == 0) {
			$(this).append(hidden.clone());
		}
	});

	window.addEventListener('focus', function() {
		$('form button').attr('disabled', 'disabled');

		$.get('/_csrf', function(data) {
			$('meta[name="csrfToken"]').attr('content', data.csrf);
			$('form button').removeAttr('disabled');
		});
	});
});

$.ajaxPrefilter(function(options) {
	if (options.type == 'get' || options.type == 'GET') {
		return;
	}
	var csrfToken = 'CSRF=' + encodeURIComponent($('meta[name="csrfToken"]').attr('content'));
	if ('data' in options) {
		options.data += '&' + csrfToken;
	} else {
		options.data = csrfToken;
	}
});
